var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "80px",
    viewBox: "0 0 81 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "done") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success",
    transform: "translate(-728.000000, -263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(570.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "done",
    transform: "translate(158.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C18,0 0,18 0,40 C0,62 18,80 40,80 C62,80 80,62 80,40 C80,18 62,0 40,0 Z",
    id: "Shape-Copy-2",
    fill: "#1ABC60",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#F2F4F7",
    strokeWidth: 6,
    points: "23 39.9555556 34.3777778 51.3333333 55 30"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckIcon);
export default __webpack_public_path__ + "static/media/success-check-icon.73661ed9dad601492b8a7174f3c18ba1.svg";
export { ForwardRef as ReactComponent };